import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Opportunities from "@/pages/Opportunities";
import OpportunityDetail from "@/pages/OpportunityDetail";
import RealEstate from "@/pages/RealEstate";
import Agriculture from "@/pages/Agriculture";
import Strategic from "@/pages/Strategic";
import HowItWorks from "@/pages/HowItWorks";
import Events from "@/pages/Events";
import Partnerships from "@/pages/Partnerships";
import Insights from "@/pages/Insights";
import BlogPost from "@/pages/BlogPost";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";
import Invest from "@/pages/Invest";
import PaymentStatus from "@/pages/PaymentStatus";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AuthCallback from "@/pages/AuthCallback";
import VerifyEmail from "@/pages/VerifyEmail";

// Playbook: synchronously detect session_id in URL fragment BEFORE routing so
// ProtectedRoute never redirects the callback URL to /login.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/investments" element={<Opportunities />} />
        <Route path="/investments/:id" element={<OpportunityDetail />} />
        <Route path="/real-estate" element={<RealEstate />} />
        <Route path="/agriculture" element={<Agriculture />} />
        <Route path="/strategic" element={<Strategic />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/events" element={<Events />} />
        <Route path="/partnerships" element={<Partnerships />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/insights/:slug" element={<BlogPost />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/legal/:kind" element={<Legal />} />
        <Route path="/dashboard" element={
          <ProtectedRoute><Dashboard /></ProtectedRoute>
        } />
        <Route path="/invest/:id" element={
          <ProtectedRoute><Invest /></ProtectedRoute>
        } />
        <Route path="/payment/:id" element={
          <ProtectedRoute><PaymentStatus /></ProtectedRoute>
        } />
        <Route path="/admin" element={
          <ProtectedRoute adminOnly><Admin /></ProtectedRoute>
        } />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
